export default __webpack_public_path__ + "static/media/image6.b4290da4.png";